<template>
  <div class="crowded-banking-page">
    <iframe
      :src="iframeSrc"
      class="crowded-banking-iframe"
      allowpaymentrequest
      allow="payment *"
      referrerpolicy="no-referrer"
    />
  </div>
</template>

<script>
const CROWDED_URLS = {
  accounts:
    "https://app.bankingcrowded.com/bank-accounts?theme=18227b19-9f68-4beb-a9a0-3d11078003f4",
  cards: "https://app.bankingcrowded.com/mycards?theme=18227b19-9f68-4beb-a9a0-3d11078003f4#admin",
  transactions:
    "https://app.bankingcrowded.com/transactionhistory?theme=18227b19-9f68-4beb-a9a0-3d11078003f4#transactions",
};

export default {
  name: "CrowdedBankingPage",
  computed: {
    iframeSrc() {
      const section = this.$route.params.section;
      return CROWDED_URLS[section] || CROWDED_URLS.accounts;
    },
  },
};
</script>

<style lang="scss" scoped>
.crowded-banking-page {
  width: 100%;
  height: calc(100vh - 90px);
  display: flex;
  flex-direction: column;
}

.crowded-banking-iframe {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
